"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentAccountCode = void 0;
/**
 * @deprecated In favor of `SystemCurrency.USDT_REWARD`.
 */
var PaymentAccountCode;
(function (PaymentAccountCode) {
    PaymentAccountCode["Regular"] = "REGULAR";
    PaymentAccountCode["Reward"] = "REWARD";
})(PaymentAccountCode = exports.PaymentAccountCode || (exports.PaymentAccountCode = {}));
//# sourceMappingURL=payment-account-code.js.map